import React from 'react';
import {
  Card,
  Icon,
  Label,
  Segment,
  Divider,
} from 'semantic-ui-react';

import axios from 'axios';
import _ from 'lodash';

import DataFetchError from '../data-fetch-error';
import { authService } from '../../utils/auth-service';

const noMarginNoPadding = {
  margin: 0,
  padding: 0,
};

const noMargin = {
  margin: 0,
};

const labelStyle = {
  cursor: 'pointer',
  margin: 3,
};

const cloudfrontTagsApi = process.env.REACT_APP_INFLUENCER_COUNTRIES_API;

class OldOrganisationTags extends React.Component {
  state = {
    tags: [],
    loading: true,
    selectedTag: null,
  };

  constructor() {
    super();
    const token = authService.getToken();
    const tagsApi = cloudfrontTagsApi;
    this.api = axios.create({
      baseURL: tagsApi,
      timeout: 10000,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  componentDidMount() {
    const { organisationId } = this.props;
    if (organisationId) {
      this.api.get(`/tags/${organisationId}`)
        .then(r => {
          const { data } = r;
          this.setState({
            tags: data.data,
            loading: false,
          });
        })
        .catch(error => {
          this.setState({
            tags: [],
            error,
            loading: false,
          });
        });
    }
  }

  handleTagClick = (e, { value }) => {
    const { handleClick } = this.props;
    const tag = value;
    this.setState({
      selectedTag: tag,
    }, handleClick({
      tag,
    }));
  }

  render() {
    const { tags, loading, selectedTag, error } = this.state;
    const tagCount = loading ? 'loading' : tags.length;
    return (
      <Card fluid color="blue" style={noMargin} >
        <Card.Content>
          <Card.Header>
            Tag Search
          </Card.Header>
          <Card.Meta>
            <br />This will search influencers tags directly.
            <br /><i>NOT</i> their handles, description or bios.
            <Divider />
            The tag search will bring back <i>all</i> matching influencers.
          </Card.Meta>
        </Card.Content>

        <Card.Content textAlign="center">
          <Segment basic loading={loading} style={noMarginNoPadding}>
            {
              _.map(tags, tag => (
                <Label
                  content={tag}
                  color={tag === selectedTag ? 'pink' : 'grey'}
                  basic={tag !== selectedTag}
                  style={labelStyle}
                  value={tag}
                  onClick={this.handleTagClick}
                />
              ))
            }
            {
              error && <DataFetchError dataDescription="influencer tags" iconSize="huge" error={error} />
            }
          </Segment>
        </Card.Content>
        <Card.Content extra textAlign="center">
          <Icon name="tags" />
          { tagCount } tags
        </Card.Content>
      </Card>
    );
  }
}

export default OldOrganisationTags;



/** WEBPACK FOOTER **
 ** ./src/components/old-organisation-tags/index.js
 **/